import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField/TextField';
import CloseIcon from '@material-ui/icons/Close';
import EventIcon from '@material-ui/icons/Event';
import { MuiTextFieldProps } from '@material-ui/pickers/_shared/PureDateInput';
import React, { useEffect, useState } from 'react';

const RenderInput = (startProps: MuiTextFieldProps, endProps: MuiTextFieldProps, handleClear: () => void) => {
  const [value, setValue] = useState<string>('');
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (startProps.inputProps.value || endProps.inputProps.value) {
      setValue(`De ${startProps.inputProps.value || '_ /_ / __'} até ${endProps.inputProps.value || '_ /_ / __'}`);
    } else {
      setValue('');
    }

    if (startProps.focused || endProps.focused) {
      setFocused(true);
    } else {
      setFocused(false);
    }
  }, [startProps.inputProps.value, endProps.inputProps.value, startProps.focused, endProps.focused]);

  const onClear = () => {
    setValue('');
    handleClear();
  };

  const InputProps = {
    endAdornment: (
      <InputAdornment position='end'>
        <IconButton disabled={true}>
          <EventIcon />
        </IconButton>
        {(startProps.inputProps.value || endProps.inputProps.value) && (
          <IconButton onClick={onClear}>
            <CloseIcon />
          </IconButton>
        )}
      </InputAdornment>
    ),
  };

  return (
    <TextField
      {...({ ...startProps, InputProps })}
      focused={focused}
      fullWidth
      inputProps={{
        ...startProps.inputProps,
        value,
        readOnly: true,
        placeholder: 'De _ /_ / __ até _ /_ / __',
      }}
      InputLabelProps={{
        shrink: true
      }}
      helperText=''
      label='Período'
      type='date'
      error={startProps.inputProps.value  > endProps.inputProps.value}
    />
  );
};

export default RenderInput;